<mat-card class="slidecontent">
    <div class="headcontent">
        <div class="pophead">
            <h3>Add User</h3>
            <mat-icon (click)="close(closePannel)" class="close">close</mat-icon>
        </div>
    </div>
    <div class="dialog_content">
        <form [formGroup]="userDetailform" class="fix-mat-form-field">

            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field appearance="legacy" fxFlex>
                    <mat-label>First Name</mat-label>
                    <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                    <input matInput maxlength="50" placeholder="First Name" formControlName="firstname"
                        (keypress)="allowAlphabetOnly($event)" #firstname>
                    <mat-error>
                        {{ titleAlert }}
                    </mat-error>
                </mat-form-field>
            </div>
            <!-- (keyup)="checkregex()" -->
            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field appearance="legacy" fxFlex>
                    <mat-label>Last Name</mat-label>
                    <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                    <input matInput maxlength="30" placeholder="Last Name" formControlName="lastname"
                        (keypress)="allowAlphabetOnly($event)">
                    <mat-error>
                        {{ titleAlert }}
                    </mat-error>
                </mat-form-field>
            </div>

            <!-- (blur)="checkInUseEmail()" -->
            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field appearance="legacy" fxFlex>
                    <mat-label>Email</mat-label>
                    <mat-icon matSuffix class="secondary-text">email</mat-icon>
                    <input matInput maxlength="50" placeholder="Email" formControlName="email" 
                        autocomplete="false">
                    <mat-error>
                        {{ getErrorEmail() }}
                    </mat-error>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field class="choose" appearance="legacy" fxFlex>
                    <mat-label>Enter your password</mat-label>
                    <input matInput [type]="hide ? 'password' : 'text'" formControlName="password"
                        placeholder="Enter your password" autocomplete="off">
                    <mat-icon class="eye" matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                        [attr.aria-pressed]="hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                    <mat-hint class="errorpass">Choose a password of at least eight characters with one uppercase
                        letter, one lowercase letter, one special character and one number
                    </mat-hint>
                    <mat-error class="errorpass">
                        {{ getErrorPassword() }}
                    </mat-error>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field appearance="legacy" fxFlex>
                    <mat-label>Confirm your password</mat-label>
                    <input matInput [type]="hide ? 'password' : 'text'" placeholder="Confirm your password"
                        formControlName="confirmPassword" (keyup)="matchPassword()" autocomplete="off">
                    <span matSuffix class="eye" (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                        [attr.aria-pressed]="hide">
                        <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </span>
                    <mat-error>
                        Password does not match
                    </mat-error>
                </mat-form-field>
            </div>



            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field class="example-full-width">
                    <mat-label>Telephone</mat-label>
                    <span matPrefix>+1 &nbsp;</span>
                    <input maxlength="10" matInput placeholder="Telephone" formControlName="phoneNumber" mask="(000) 000-0000">
                    <mat-error>{{getPhoneErrorMessage()}}</mat-error>
                    <mat-icon matSuffix>local_phone</mat-icon>
                </mat-form-field>
            </div>

            <div  class="selectedPermission" *ngIf="selectedOfficeArray.length > 0" >
                <h4 _ngcontent-rnx-c336="">Selected Office</h4>
                <div class="selList">
                    <span *ngFor="let o of selectedOfficeArray">
                        <h4>{{o.officeName}}</h4>
                        <button mat-icon-button><mat-icon (click)="removeSelectedOffice(o)">cancel</mat-icon></button>
                    </span>
                </div>
            </div>
            
            <mat-form-field  appearance="" class="mt-10 mb-10" style="position: relative;">
                <mat-label>Search Office</mat-label>
                <input matInput
                       placeholder= "Type & Select"
                       aria-label="State"
                       [matAutocomplete]="auto" 
                       (input)="searchOfficeFun($event.target.value)" 
                       [formControl]="officectrl"
                       id="officectrlId"                       
                       >
                 <mat-autocomplete #auto="matAutocomplete">
                  <mat-option (keydown.enter)="selectedOffice(office)"
                  (click)="selectedOffice(office)" *ngFor="let office of searchOffice" [value]="office.officeName">
                    <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
                        <!-- <div class="userpic">
                            <img *ngIf="contact.imageUrl!=''" src="{{contact.imageUrl}}" alt="">
                            <span class="username" *ngIf="contact.imageUrl==''" class="username">
                                {{contact.shortName}}
                              </span>
                        </div> -->
                        <div class="info">
                          <p> {{ office.officeName }}</p>
                          <!-- <p class="email">{{ contact.email }}</p> -->
                        </div> 
                    </span>
                  </mat-option>
                </mat-autocomplete>
               
              </mat-form-field>
              
            
              <div class="selectedPermission mb-5">
                <h4>Select Roles </h4>
                <div class="multiDrop">
                    <ng-multiselect-dropdown
                    [placeholder]="'Search or Select'"
                    [settings]="dropdownSettings"
                    [data]="dropdownList"
                    [(ngModel)]="selectedItems"
                    formControlName="selectedroles"                
                    name="selectedroles">
                    </ng-multiselect-dropdown>
                   </div>
            </div>   

            <!-- <div fxLayout="row" fxLayoutAlign="start start">
                <mat-list-item role="listitem" class="fullw">
                    <mat-form-field appearance="legacy" fxFlex class="rolesDropdown ">
                        <mat-select placeholder="Roles" name="role" formControlName="selectedroles" multiple>
                            <mat-option *ngFor="let role of roles" [value]="role.roleID">
                                {{role.roleName}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </mat-list-item>
            </div> -->

            <div appearance="legacy" fxFlex>
                <mat-checkbox formControlName="isActive" color="primary" [(ngModel)]="isActiveChecked">Active
                </mat-checkbox>
            </div>
        </form>

    </div>



    <div class="actionBtn">
        <button mat-flat-button class="cancel" (click)="close(closePannel)">Cancel</button>
        <button mat-flat-button class="calltoaction" type="submit" 
        [disabled]="userDetailform.invalid || !userDetailform.dirty"        
        (click)="save(userDetailform.value)" color="primary">Create
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
        </mat-spinner></mat-icon>
    </button>
    </div>
</mat-card>

<div class="overlay" (click)="close(closePannel)" ></div>
  

